import React from 'react';
import { Reveal } from './Reveal';
const bonuses = [{
  tag: 'Bono 1',
  title: 'Plan de Caminatas según tu Nivel',
  text: 'Una guía clara para elegir tus caminatas según tu punto de partida y avanzar a tu ritmo con seguridad.'
}, {
  tag: 'Bono 2',
  title: 'Checklist de Hábitos que Potencian tu Progreso',
  text: 'Una lista práctica de hábitos simples que acompañan tus caminatas y te ayudan a sostener los resultados.'
}, {
  tag: 'Bono 3',
  title: 'Errores Frecuentes y Cómo Corregirlos',
  text: 'Identificá los errores que pueden frenar tu progreso y aprendé cómo corregirlos de forma simple.'
}];
export function Bonuses() {
  return <section className="w-full bg-white" data-id="element-16" data-mp="3t0g6egxh6gen">
      <div className="mx-auto max-w-6xl px-5 py-16 sm:py-24" data-id="element-17" data-mp="3t1hjss1yrezj">
        <Reveal className="mx-auto max-w-2xl text-center" data-id="element-18" data-mp="1m9qi5h3uhjkr">
          <h2 className="font-display text-3xl font-bold text-ink sm:text-4xl" data-id="element-19" data-mp="1m85m1n1vtsks">
            🎁 3 Bonos de regalo incluidos con tu inscripción
          </h2>
          <p className="mt-4 text-lg text-ink/70" data-id="element-20" data-mp="3ideke10bxu2r">
            Además de los 6 módulos, recibís estos regalos que potencian todo lo que aprendés.
          </p>
        </Reveal>

        <div className="mt-12 grid grid-cols-1 gap-6 lg:grid-cols-3" data-id="element-21" data-mp="3r6i3aotquz4s">
          {bonuses.map((b, i) => <Reveal key={b.tag} delay={i * 0.08} data-id="element-22" data-mp="3n4mwx5wyhvk5" data-mpi={i}>
              <div className="relative h-full rounded-2xl border-2 border-dashed border-brand/40 bg-brand-light/50 p-7" data-id="element-23" data-mp="3n5y6jmd31xj6">
                <span className="inline-flex rounded-full bg-brand px-3 py-1 text-xs font-bold uppercase tracking-wide text-white" data-id="element-24" data-mp="2ugh9gbeipsgm">
                  🎁 {b.tag}
                </span>
                <h3 className="mt-4 text-lg font-bold text-ink" data-id="element-25" data-mp="38e5ubj8l4zlo">{b.title}</h3>
                <p className="mt-2 text-sm leading-relaxed text-ink/70" data-id="element-26" data-mp="33fm8rjxwlptu">{b.text}</p>
              </div>
            </Reveal>)}
        </div>
      </div>
    </section>;
}